import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';

import { Theme } from '@app/theme';
import { Button, IconChip } from '@app/core';

interface Props {
  text: string;
  className?: string;
  isLoading?: boolean;
  onClick: () => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginTop: theme.marginBase * 3,
    marginBottom: theme.marginBase * 3,
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.marginBase * 2,
    width: '100%',
  },
  width: {
    width: '100%',

    // The shared spinner paints its dots white, which is invisible on the muted
    // background of this button.
    '& .dot-elastic, & .dot-elastic::before, & .dot-elastic::after': {
      backgroundColor: theme.colors.inkPrimary,
    },
  },
}));

export const IaSuggestionButton = ({
  text,
  className,
  isLoading,
  onClick,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classnames(classes.container, className)}>
      <Button
        color="ink"
        variant="muted"
        className={classes.width}
        contentClassName={classes.button}
        onClick={onClick}
        isLoading={isLoading}
        disabled={isLoading}
      >
        <IconChip icon="ri-sparkling-2-line" color="accent">
          Beta
        </IconChip>
        <span>{text}</span>
      </Button>
    </div>
  );
};
